import BusinessSettingsLayout from '@/layouts/BusinessSettingsLayout.vue'

export const SETTINGS_ROUTES = [
  {
    path: 'business',
    component: BusinessSettingsLayout,
    redirect: { name: 'EditAppointmentSettings' },
    children: [
      {
        path: 'appointments',
        name: 'EditAppointmentSettings',
        component: () => import('./appointmentSettings/views/EditAppointmentSettings.vue'),
      },
      {
        path: 'quotes',
        name: 'EditQuoteSettings',
        component: () => import('./quoteSettings/views/EditQuoteSettings.vue'),
      },
      {
        path: 'invoices',
        name: 'EditInvoiceSettings',
        component: () => import('./invoiceSettings/views/EditInvoiceSettings.vue'),
      },
      {
        path: 'schedule',
        name: 'EditScheduleSettings',
        component: () => import('./scheduleSettings/views/EditScheduleSettings.vue'),
      },
      {
        path: 'payroll',
        name: 'EditPayrollSettings',
        component: () => import('./payrollSettings/views/EditPayrollSettings.vue'),
      },
    ],
  },
  {
    path: 'email-templates',
    name: 'EmailTemplateList',
    component: () => import('./emailTemplates/views/EmailTemplateList.vue'),
  },
  {
    path: 'email-templates/:id/edit',
    name: 'EditEmailTemplate',
    component: () => import('./emailTemplates/views/EditEmailTemplate.vue'),
  },
  {
    path: 'notification-profiles',
    name: 'NotificationProfileList',
    component: () => import('./notificationProfiles/views/NotificationProfileList.vue'),
  },
  {
    path: 'notification-profiles/create',
    name: 'CreateNotificationProfile',
    component: () => import('./notificationProfiles/views/CreateNotificationProfile.vue'),
  },
  {
    path: 'notification-profiles/:id/edit',
    name: 'EditNotificationProfile',
    component: () => import('./notificationProfiles/views/EditNotificationProfile.vue'),
  },
]
